import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuoteCmsPageResolver } from '@common/data-access-quotes';
import { SkyErrorComponent } from '@domgen/dgx-ui-whitelabel-components';

import { JourneyTypeGuard } from './guards/journey-type-guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/quote',
    pathMatch: 'full',
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: '.html',
    redirectTo: '/quote',
    pathMatch: 'full',
  },
  {
    path: 'quote',
    loadChildren: () =>
      import('@sky/feature-select-device').then(
        (module) => module.SkyFeatureSelectDeviceModule
      ),
    canActivate: [JourneyTypeGuard],
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: 'quote.html',
    redirectTo: '/quote',
    pathMatch: 'full',
  },
  {
    path: 'basket',
    loadChildren: () =>
      import('@sky/feature-basket').then(
        (module) => module.SkyFeatureBasketModule
      ),
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: 'basket.html',
    redirectTo: '/basket',
    pathMatch: 'full',
  },
  {
    path: 'add-device',
    loadChildren: () =>
      import('@sky/feature-add-device').then(
        (module) => module.SkyFeatureAddDeviceModule
      ),
  },
  {
    path: 'add-mobile',
    loadChildren: () =>
      import('@sky/feature-add-device').then(
        (module) => module.SkyFeatureAddMobileModule
      ),
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: 'add-device.html',
    redirectTo: '/add-device',
    pathMatch: 'full',
  },
  {
    path: 'checkout',
    children: [
      {
        path: 'personal-details',
        loadChildren: () =>
          import('@sky/feature-checkout-personal-details').then(
            (m) => m.SkyFeatureCheckoutPersonalDetailsModule
          ),
        resolve: {
          quoteData: QuoteCmsPageResolver,
        },
      },
      {
        path: 'direct-debit-payment',
        loadChildren: () =>
          import('@sky/feature-checkout-direct-debit').then(
            (m) => m.SkyFeatureCheckoutDirectDebitModule
          ),
      },
      {
        path: 'order-confirmation',
        loadChildren: () =>
          import('@sky/feature-order-confirmation').then(
            (m) => m.SkyFeatureOrderConfirmationModule
          ),
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'personal-details',
      },
    ],
  },
  { path: 'error', data: { title: 'Error' }, component: SkyErrorComponent },
  { path: '**', redirectTo: '/quote' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      paramsInheritanceStrategy: 'always',
      relativeLinkResolution: 'corrected',
    }),
  ],
  providers: [JourneyTypeGuard],
  exports: [RouterModule],
})
export class SkyFeatureShellRoutingModule {} // Main routes for application
